<script setup>
</script>

<template>
    <div class="allscreen">
        <div class="flex align-items-center">
            <span class="mr-3 text-3xl">Загрузка</span>
            <span class="loading-bars"></span>
        </div>
    </div>
</template>

<style scoped>
.allscreen {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
}

</style>